<div class="contenidor">
    <div class="container">
        Hola welcome
    </div>
</div>